import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import { misc } from "app/themes/colors";
import { FORM_TEMPLATE_TYPES } from "constants/form-templates";
import { FormTemplate } from "services/types/form-templates.type";

import { isDigitalForm } from "./digital-forms.utils";

type FormTemplateListItemProps = {
  props: React.ComponentProps<typeof ListItem>;
  option: FormTemplate;
};

// ENG-2277: a digital Form reads like a digital purchase agreement: yellow, marked Digital, with
// "Form · <category>" beneath its name.
function DigitalFormCaption({ option }: { option: FormTemplate }) {
  const category = option.text_template_meta?.category?.title;
  return (
    <Box
      component="span"
      sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
    >
      <Chip
        component="span"
        label="Digital"
        size="small"
        variant="outlined"
        sx={{
          height: 20,
          fontSize: 12,
          fontWeight: 700,
          color: "warning.dark",
          borderColor: "warning.main",
          bgcolor: "background.paper"
        }}
      />
      <span>{category ? `Form · ${category}` : "Form"}</span>
    </Box>
  );
}

export default function FormTemplateListItem({
  props,
  option
}: FormTemplateListItemProps) {
  const digital = isDigitalForm(option);
  return (
    <ListItem
      {...props}
      key={option.id}
      sx={{
        ...props?.sx,
        mt: -0.5,
        ...(digital && { background: misc.lightYellow })
      }}
      data-testid="form-template-item"
    >
      <ListItemText
        secondary={
          digital ? (
            <DigitalFormCaption option={option} />
          ) : (
            FORM_TEMPLATE_TYPES.getFromCode(option.type as number)
          )
        }
        secondaryTypographyProps={digital ? { component: "span" } : undefined}
      >
        {option.title}
      </ListItemText>
    </ListItem>
  );
}
